import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { Store } from '@ngrx/store';
import { catchError, map, Observable, of, take } from 'rxjs';
import { PageUtils } from '../common/page.utils';
import { AssessApiService } from '../services/assess-api.service';
import { setCampaignContent } from '../store/actions/campaign.actions';
import { AssessmentPageState } from '../store/models/assessment-models';
import { LoggingService } from '../services/logging.service';
import { PublicRoutePathParameters } from '../models/assessment-models';

@Injectable({
  providedIn: 'root',
})
export class ContentGuardV1 implements CanActivate {
  constructor(
    private readonly assessApiService: AssessApiService,
    private readonly pageUtils: PageUtils,
    private readonly store: Store<AssessmentPageState>,
    private readonly logger: LoggingService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const routeParams: PublicRoutePathParameters = this.pageUtils.getLandingRoutePathParameters(route);

    return this.assessApiService.getCampaignContentV1(routeParams.orgCode, routeParams.campaignCode).pipe(
      take(1),
      map((response) => {
        this.store.dispatch(setCampaignContent({ content: response.contents }));
        return true;
      }),
      catchError((err: HttpErrorResponse) => {
        this.logger.logException(err, 3);
        console.log('Error retrieving campaign content: \n', err);

        return of(false);
      }),
    );
  }
}
